// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"pagination_paginationWrapper__wcRcA","info":"pagination_info__IjKQ8","pageItem":"pagination_pageItem__5lbnk","disabled":"pagination_disabled__PoiTs"};